import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { API_BASE } from "./api";

/**
 * Cliente de Better Auth.
 *
 * La sesion vive en una cookie compartida entre dashboard y API (la API es
 * subdominio hijo del dashboard — ver el invariante de cookie en
 * `better-auth.ts` del worker). NO se usa header Bearer.
 *
 * Detalle del cliente react de Better Auth: los metodos DEVUELVEN `{ error }`,
 * no tiran. Un `try/catch` alrededor de `signIn.email(...)` nunca ve el error y
 * el usuario se queda mirando un formulario que no reacciona — hay que
 * inspeccionar `result.error` explicitamente.
 */
export const authClient = createAuthClient({
  baseURL: `${API_BASE}/api/auth`,
  plugins: [magicLinkClient()],
});
